import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => {
  const pageBackground = theme.palette.grey[400];

  return createStyles({
    container: {
      width: "100%",
      height: "100vh",
      display: "flex",
      flexDirection: "row",
      direction: "ltr",
      background: pageBackground,
      overflow: "hidden",
    },
    contentWrapper: {
      flex: 1,
      minWidth: 0,
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      background: pageBackground,
      overflow: "hidden",
    },
    topbarWrapper: {
      width: "100%",
      flexShrink: 0,
      position: "sticky",
      top: 0,
      zIndex: 100,
      background: theme.palette.background.paper,
    },
    content: {
      flex: 1,
      minHeight: 0,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    },
  });
});
